export default __webpack_public_path__ + "static/media/invoice-logo.92cbdf15.png";